import {IMruCommand, IMruDevice, IMruLocation} from 'interfaces';
import {axiosAPI} from './API';

// Singleton for interacting with mrus
class _MruService {

    public mruDevices: IMruDevice[] = [];
    public mruLocations: IMruLocation[] = [];
    public mruCommands: IMruCommand[] = [];

    public getMruDevices = (): Promise<IMruDevice[]> => {

        const p = axiosAPI.get<IMruDevice[]>('/devices/mru')
            .then((resp) => {
                let ds = resp.data;
                ds.sort((a, b) => b.lastRequested - a.lastRequested)
                this.mruDevices = ds;
                return ds;
            });
            
        p.catch((err) => {
            console.error('Error getting all mru devices: ', err);
        });

        return p;
    }

    public getMruLocations = (): Promise<IMruLocation[]> => {

        const p = axiosAPI.get<IMruLocation[]>('/locations/mru')
            .then((resp) => {
                let ls = resp.data;
                ls.sort((a, b) => b.lastRequested - a.lastRequested)
                this.mruLocations = ls;
                return ls;
            });
            
        p.catch((err) => {
            console.error('Error getting all mru locations: ', err);
        });

        return p;
    }

    public getMruCommands = (): Promise<IMruCommand[]> => {

        const p = axiosAPI.get<IMruCommand[]>('/command/mru')
            .then((resp) => {
                let cs = resp.data;
                cs.sort((a, b) => b.lastRequested - a.lastRequested)
                this.mruCommands = cs;
                return cs;
            });
            
        p.catch((err) => {
            console.error('Error getting all mru locations: ', err);
        });

        return p;
    }
}

export const MruService = new _MruService();
